import gql from 'graphql-tag'


export const CreateLecture = gql`
mutation CreateLecture($videoLink: String, $pdfLink: String, $category: String, $grade: Int, $title: String) {
  createLecture(videoLink: $videoLink, pdfLink: $pdfLink, category: $category, grade: $grade, title: $title) {
    lecture {
      id
      videoLink
      pdfLink
      grade
      category
      title
    }
  }
}
`


export const UpdateLecture = gql`
mutation UpdateLecture($id: ID!, $videoLink: String, $pdfLink: String, $category: String, $grade: Int, $title: String) {
  updateLecture(id: $id, videoLink: $videoLink, pdfLink: $pdfLink, category: $category,  grade: $grade, title: $title) {
    lecture {
      id
      videoLink
      pdfLink
      grade
      category
      title
    }
  }
}
`


export const DeleteLecture = gql`
mutation DeleteLecture($id: ID!) {
  deleteLecture(id: $id) {
    id_
  }
}
`
